import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../../../Seller/Sidebar';
import ProfileMain from '../Profile/ProfileMain';
import ProfileEmpty from '../Profile/ProfileEmpty';

const ProfileContent = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB',
        overflowX: 'hidden',
        gap: '2px',
        flexDirection: { xs: 'column', md: 'row' },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {/* ✅ Hide Sidebar on mobile */}
      {!isMobile && <Sidebar />}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          minWidth: 0,
          mr: { xs: 0, md: '80px' },
          ml: { xs: 0, md: '25px' },
          pt: { xs: '16px', md: '32px' },
          pb: { xs: '16px', md: '32px' },
        }}
      >
        <ProfileMain />
        <ProfileEmpty />
      </Box>
    </Box>
  );
};

export default ProfileContent;